import { defineComponent as _defineComponent } from 'vue'
import { normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, createElementBlock as _createElementBlock, renderList as _renderList, Fragment as _Fragment, TransitionGroup as _TransitionGroup } from "vue"

const _hoisted_1 = { class: "d-flex flex-column flex-column-fluid" }
const _hoisted_2 = { class: "nav nav-custom nav-tabs nav-line-tabs nav-line-tabs-2x border-0 fs-4 fw-semobold mb-8" }
const _hoisted_3 = { class: "nav-item" }
const _hoisted_4 = { class: "nav-item" }
const _hoisted_5 = { class: "nav-item" }
const _hoisted_6 = { class: "nav-item" }
const _hoisted_7 = { class: "card mb-5 mb-xl-8" }
const _hoisted_8 = { class: "card-header" }
const _hoisted_9 = {
  class: "card-title d-flex justify-content-between",
  style: {"width":"100%"}
}
const _hoisted_10 = { class: "d-flex" }
const _hoisted_11 = { class: "me-5" }
const _hoisted_12 = { class: "me-5" }
const _hoisted_13 = { class: "card-body" }
const _hoisted_14 = {
  class: "table align-middle table-row-dashed fs-6 table-hover",
  id: "table_accounts_requests"
}
const _hoisted_15 = /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("tr", { class: "text-start text-muted fw-bold fs-7 text-uppercase gs-0" }, [
    /*#__PURE__*/_createElementVNode("th", null, "Sales Uid"),
    /*#__PURE__*/_createElementVNode("th", null, "Trade Account No."),
    /*#__PURE__*/_createElementVNode("th", null, "Rebate ID"),
    /*#__PURE__*/_createElementVNode("th", null, "Ticket"),
    /*#__PURE__*/_createElementVNode("th", null, "Rebate Type"),
    /*#__PURE__*/_createElementVNode("th", null, "Rebate Base"),
    /*#__PURE__*/_createElementVNode("th", null, "Wallet Adjust ID"),
    /*#__PURE__*/_createElementVNode("th", null, "Wallet ID"),
    /*#__PURE__*/_createElementVNode("th", null, "Amount"),
    /*#__PURE__*/_createElementVNode("th", null, "Status"),
    /*#__PURE__*/_createElementVNode("th", null, "CreatedOn"),
    /*#__PURE__*/_createElementVNode("th", null, "Pause")
  ])
], -1)
const _hoisted_16 = {
  key: 0,
  style: {"height":"300px"}
}
const _hoisted_17 = { colspan: "12" }
const _hoisted_18 = { key: 1 }
const _hoisted_19 = { colspan: "12" }
const _hoisted_20 = ["onClick"]
const _hoisted_21 = { key: 0 }
const _hoisted_22 = { key: 1 }
const _hoisted_23 = { key: 0 }
const _hoisted_24 = { key: 1 }
const _hoisted_25 = { key: 0 }
const _hoisted_26 = { key: 1 }
const _hoisted_27 = { key: 2 }
const _hoisted_28 = { key: 0 }

import { ref, onMounted, watch } from "vue";
import TimeShow from "@/components/TimeShow.vue";
import RebateService from "../services/RebateService";
import SchemaDetail from "../components/SalesRebateSchemaDetail.vue";
import SchemaNote from "../components/SalesRebateSchemaNote.vue";
import TableFooter from "@/components/TableFooter.vue";
import ScaleLoader from "vue-spinner/src/ScaleLoader.vue";
import BalanceShow from "@/components/BalanceShow.vue";
import SalesRebateExportModal from "../components/modal/SalesRebateExportModal.vue";
import { convertToUTC } from "@/core/utils/DateUtils";
// import { isDateInDST_US } from "@/core/plugins/TimerService";
// import { useI18n } from "vue-i18n";
// import moment from "moment";


export default /*#__PURE__*/_defineComponent({
  __name: 'SalesRebateRecord',
  setup(__props) {

const isLoading = ref(true);
const SchemaNoteRef = ref<any>(null);
const SchemaDetailRef = ref<any>(null);
const data = ref({} as any);
const accountSelected = ref(0);
const period = ref([] as any);
const isSubmitting = ref(false);

const tabStatus = ref({
  Pending: 0,
  Completed: 1,
  Pause: 6,
  All: null,
});

const allPageStatus = ref(tabStatus.value.All) as any;
const tab = ref(tabStatus.value.Pending) as any;
const salesRebateExportModalRef = ref<any>(null);
const criteria = ref<any>({
  page: 1,
  size: 20,
  salesAccountUid: "",
  tradeAccountNumber: "",
  ticket: "",
});

const reset = () => {
  criteria.value.page = 1;
  criteria.value.size = 20;
  criteria.value.salesAccountUid = "";
  criteria.value.tradeAccountNumber = "";
  criteria.value.ticket = "";
  criteria.value.from = null;
  criteria.value.to = null;
  period.value = [];
  allPageStatus.value = tabStatus.value.All;
  fetchData(1, tab.value);
};

onMounted(async () => {
  fetchData(1, tabStatus.value.Pending);
});

const refresh = () => {
  fetchData(1, tabStatus.value.Pending);
};

const getTagType = (status: number) => {
  switch (status) {
    case 1:
      return "success";
    case 0:
      return "warning";
    case 6:
      return "info";
    default:
      return "primary";
  }
};

const fetchData = async (_page: number, status: any) => {
  isLoading.value = true;
  criteria.value.page = _page;
  const datesRange = convertToUTC(period.value);
  criteria.value.from = datesRange.from;
  criteria.value.to = datesRange.to;
  if (allPageStatus.value !== tabStatus.value.All) {
    criteria.value.status = allPageStatus.value;
  } else {
    criteria.value.status = status;
  }

  try {
    const res = await RebateService.querySalesRebate(criteria.value);
    criteria.value = res.criteria;
    data.value = res.data;
  } catch (error) {
    console.log(error);
  } finally {
    isLoading.value = false;
  }
};

const selectedAccount = (id: number) => {
  accountSelected.value = id;
};

const pageChange = (_page: number) => {
  fetchData(_page, tab.value);
};

const confirmSearch = () => {
  fetchData(1, allPageStatus.value);
};

const showSchemaNote = (_item: any) => {
  SchemaNoteRef.value.show(_item);
};

const toggleActiveStatus = async (item: any) => {
  console.log(status);
  isSubmitting.value = true;

  try {
    const res = await RebateService.updateSalesRebateActiveStatus(item.id, {
      status: item.status,
    });
  } catch (error) {
    console.log(error);
  } finally {
    isSubmitting.value = false;
  }
};

const openSalesRebateExportModal = () => {
  const currentQuery = {
    from: criteria.value.from,
    to: criteria.value.to,
    salesAccountUid: criteria.value.salesAccountUid,
    tradeAccountNumber: criteria.value.tradeAccountNumber,
    ticket: criteria.value.ticket,
    status: allPageStatus.value,
  };

  salesRebateExportModalRef.value?.show(currentQuery, period.value);
};

// watch(
//   () => period.value,
//   (periodVal) => {
//     const [from, to] = periodVal;
//     const isDST = isDateInDST_US();
//     criteria.value.from = from
//       ? moment(from)
//           .subtract(1, "days")
//           .format(`YYYY-MM-DD[T]${isDST ? 21 : 22}:00:00.000[Z]`)
//       : null;
//     criteria.value.to = to
//       ? moment(to)
//           .subtract(1, "days")
//           .format(`YYYY-MM-DD[T]${isDST ? 20 : 21}:59:59.000[Z]`)
//       : null;
//   }
// );

return (_ctx: any,_cache: any) => {
  const _component_el_date_picker = _resolveComponent("el-date-picker")!
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_tag = _resolveComponent("el-tag")!
  const _component_el_switch = _resolveComponent("el-switch")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("ul", _hoisted_2, [
      _createElementVNode("li", _hoisted_3, [
        _createElementVNode("a", {
          class: _normalizeClass(["nav-link text-active-primary pb-4", [
            { active: tab.value === tabStatus.value.Pending },
            { 'disabled opacity-50 pe-none': isLoading.value },
          ]]),
          "data-bs-toggle": "tab",
          href: "#",
          onClick: _cache[0] || (_cache[0] = ($event: any) => ((tab.value = tabStatus.value.Pending), fetchData(1, tabStatus.value.Pending)))
        }, "Pending", 2)
      ]),
      _createElementVNode("li", _hoisted_4, [
        _createElementVNode("a", {
          class: _normalizeClass(["nav-link text-active-primary pb-4", [
            { active: tab.value === tabStatus.value.Completed },
            { 'disabled opacity-50 pe-none': isLoading.value },
          ]]),
          "data-bs-toggle": "tab",
          href: "#",
          onClick: _cache[1] || (_cache[1] = ($event: any) => (
            (tab.value = tabStatus.value.Completed), fetchData(1, tabStatus.value.Completed)
          ))
        }, "Complete", 2)
      ]),
      _createElementVNode("li", _hoisted_5, [
        _createElementVNode("a", {
          class: _normalizeClass(["nav-link text-active-primary pb-4", [
            { active: tab.value === tabStatus.value.Pause },
            { 'disabled opacity-50 pe-none': isLoading.value },
          ]]),
          "data-bs-toggle": "tab",
          href: "#",
          onClick: _cache[2] || (_cache[2] = ($event: any) => ((tab.value = tabStatus.value.Pause), fetchData(1, tabStatus.value.Pause)))
        }, "Pause", 2)
      ]),
      _createElementVNode("li", _hoisted_6, [
        _createElementVNode("a", {
          class: _normalizeClass(["nav-link text-active-primary pb-4", [
            { active: tab.value === tabStatus.value.All },
            { 'disabled opacity-50 pe-none': isLoading.value },
          ]]),
          "data-bs-toggle": "tab",
          href: "#",
          onClick: _cache[3] || (_cache[3] = ($event: any) => ((tab.value = tabStatus.value.All), fetchData(1, tabStatus.value.All)))
        }, "All (Export)", 2)
      ])
    ]),
    _createElementVNode("div", _hoisted_7, [
      _createElementVNode("div", _hoisted_8, [
        _createElementVNode("div", _hoisted_9, [
          _createElementVNode("div", _hoisted_10, [
            _createElementVNode("div", _hoisted_11, [
              _createVNode(_component_el_date_picker, {
                class: "w-250px",
                modelValue: period.value,
                "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((period).value = $event)),
                type: "daterange",
                "start-placeholder": _ctx.$t('fields.startDate'),
                "end-placeholder": _ctx.$t('fields.endDate'),
                disabled: isLoading.value,
                format: "YYYY-MM-DD",
                "value-format": "YYYY-MM-DD HH:mm:ss"
              }, null, 8, ["modelValue", "start-placeholder", "end-placeholder", "disabled"])
            ]),
            _createElementVNode("div", _hoisted_12, [
              (tab.value == tabStatus.value.All)
                ? (_openBlock(), _createBlock(_component_el_select, {
                    key: 0,
                    modelValue: allPageStatus.value,
                    "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((allPageStatus).value = $event)),
                    onChange: confirmSearch,
                    class: "w-150px",
                    placeholder: _ctx.$t('fields.status'),
                    clearable: "",
                    disabled: isLoading.value
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_option, {
                        value: "0",
                        label: "Pending"
                      }),
                      _createVNode(_component_el_option, {
                        value: "1",
                        label: "Complete"
                      })
                    ]),
                    _: 1
                  }, 8, ["modelValue", "placeholder", "disabled"]))
                : _createCommentVNode("", true)
            ]),
            _createVNode(_component_el_input, {
              modelValue: criteria.value.salesAccountUid,
              "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((criteria.value.salesAccountUid) = $event)),
              placeholder: "Sales UID",
              clearable: "",
              disabled: isLoading.value
            }, null, 8, ["modelValue", "disabled"]),
            _createVNode(_component_el_input, {
              class: "ms-5",
              modelValue: criteria.value.tradeAccountNumber,
              "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((criteria.value.tradeAccountNumber) = $event)),
              placeholder: "Account Number",
              clearable: "",
              disabled: isLoading.value
            }, null, 8, ["modelValue", "disabled"]),
            _createVNode(_component_el_input, {
              class: "ms-5",
              modelValue: criteria.value.ticket,
              "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((criteria.value.ticket) = $event)),
              placeholder: "Ticket Number",
              clearable: "",
              disabled: isLoading.value
            }, null, 8, ["modelValue", "disabled"]),
            _createVNode(_component_el_button, {
              class: "ms-5",
              onClick: _cache[9] || (_cache[9] = ($event: any) => (fetchData(1, tab.value))),
              disabled: isLoading.value
            }, {
              default: _withCtx(() => [
                _createTextVNode("Search")
              ]),
              _: 1
            }, 8, ["disabled"]),
            _createVNode(_component_el_button, {
              class: "ms-5",
              onClick: reset,
              disabled: isLoading.value
            }, {
              default: _withCtx(() => [
                _createTextVNode("Reset")
              ]),
              _: 1
            }, 8, ["disabled"]),
            (tab.value == tabStatus.value.All)
              ? (_openBlock(), _createBlock(_component_el_button, {
                  key: 0,
                  type: "success",
                  onClick: openSalesRebateExportModal,
                  disabled: isLoading.value,
                  plain: ""
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.$t("action.export")), 1)
                  ]),
                  _: 1
                }, 8, ["disabled"]))
              : _createCommentVNode("", true)
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_13, [
        _createElementVNode("table", _hoisted_14, [
          _hoisted_15,
          (isLoading.value)
            ? (_openBlock(), _createElementBlock("tbody", _hoisted_16, [
                _createElementVNode("tr", null, [
                  _createElementVNode("td", _hoisted_17, [
                    _createVNode(ScaleLoader)
                  ])
                ])
              ]))
            : _createCommentVNode("", true),
          (!isLoading.value && data.value.length === 0)
            ? (_openBlock(), _createElementBlock("tbody", _hoisted_18, [
                _createElementVNode("tr", null, [
                  _createElementVNode("td", _hoisted_19, _toDisplayString(_ctx.$t("tip.nodata")), 1)
                ])
              ]))
            : _createCommentVNode("", true),
          (!isLoading.value && data.value.length != 0)
            ? (_openBlock(), _createBlock(_TransitionGroup, {
                key: 2,
                tag: "tbody",
                name: "table-delete-fade",
                class: "table-delete-fade-container text-gray-600 fw-semibold"
              }, {
                default: _withCtx(() => [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(data.value, (item) => {
                    return (_openBlock(), _createElementBlock("tr", {
                      key: item,
                      class: _normalizeClass({
                'account-select': item.id === accountSelected.value,
              }),
                      onClick: ($event: any) => (selectedAccount(item.id))
                    }, [
                      _createElementVNode("td", null, _toDisplayString(item.salesAccountUid), 1),
                      _createElementVNode("td", null, _toDisplayString(item.tradeAccountNumber), 1),
                      _createElementVNode("td", null, _toDisplayString(item.tradeRebateId), 1),
                      _createElementVNode("td", null, _toDisplayString(item.ticket), 1),
                      _createElementVNode("td", null, _toDisplayString(item.rebateType), 1),
                      _createElementVNode("td", null, [
                        _createVNode(BalanceShow, {
                          balance: item.rebateBase
                        }, null, 8, ["balance"])
                      ]),
                      _createElementVNode("td", null, [
                        (item.status == 0)
                          ? (_openBlock(), _createElementBlock("span", _hoisted_21, "--"))
                          : _createCommentVNode("", true),
                        (item.status == 1)
                          ? (_openBlock(), _createElementBlock("span", _hoisted_22, _toDisplayString(item.walletAdjustId), 1))
                          : _createCommentVNode("", true)
                      ]),
                      _createElementVNode("td", null, [
                        (item.status == 0)
                          ? (_openBlock(), _createElementBlock("span", _hoisted_23, "--"))
                          : _createCommentVNode("", true),
                        (item.status == 1)
                          ? (_openBlock(), _createElementBlock("span", _hoisted_24, _toDisplayString(item.walletId), 1))
                          : _createCommentVNode("", true)
                      ]),
                      _createElementVNode("td", null, "$ " + _toDisplayString(item.amount / 10000), 1),
                      _createElementVNode("td", null, [
                        _createVNode(_component_el_tag, {
                          type: getTagType(item.status),
                          effect: "dark",
                          class: "fs-6"
                        }, {
                          default: _withCtx(() => [
                            (item.status == 0)
                              ? (_openBlock(), _createElementBlock("span", _hoisted_25, "Pending"))
                              : _createCommentVNode("", true),
                            (item.status == 1)
                              ? (_openBlock(), _createElementBlock("span", _hoisted_26, "Complete"))
                              : _createCommentVNode("", true),
                            (item.status == 6)
                              ? (_openBlock(), _createElementBlock("span", _hoisted_27, "Pause"))
                              : _createCommentVNode("", true)
                          ]),
                          _: 2
                        }, 1032, ["type"])
                      ]),
                      _createElementVNode("td", null, [
                        _createVNode(TimeShow, {
                          "date-iso-string": item.createdOn
                        }, null, 8, ["date-iso-string"])
                      ]),
                      (item.status == 0 || item.status == 6)
                        ? (_openBlock(), _createElementBlock("td", _hoisted_28, [
                            _createVNode(_component_el_switch, {
                              modelValue: item.status,
                              "onUpdate:modelValue": ($event: any) => ((item.status) = $event),
                              "active-value": 6,
                              "inactive-value": 0,
                              onChange: ($event: any) => (toggleActiveStatus(item)),
                              disabled: isSubmitting.value
                            }, null, 8, ["modelValue", "onUpdate:modelValue", "onChange", "disabled"])
                          ]))
                        : _createCommentVNode("", true)
                    ], 10, _hoisted_20))
                  }), 128))
                ]),
                _: 1
              }))
            : _createCommentVNode("", true)
        ]),
        _createVNode(TableFooter, {
          onPageChange: pageChange,
          criteria: criteria.value
        }, null, 8, ["criteria"])
      ]),
      _createVNode(SchemaDetail, {
        ref_key: "SchemaDetailRef",
        ref: SchemaDetailRef,
        onRefresh: refresh
      }, null, 512),
      _createVNode(SchemaNote, {
        ref_key: "SchemaNoteRef",
        ref: SchemaNoteRef
      }, null, 512),
      _createVNode(SalesRebateExportModal, {
        ref_key: "salesRebateExportModalRef",
        ref: salesRebateExportModalRef
      }, null, 512)
    ])
  ]))
}
}

})